import type { Nullable } from '~/types/generics';

export const safeJsonParse = <T>(jsonString: string): Nullable<T> => {
  try {
    return JSON.parse(jsonString) as T;
  } catch (e: unknown) {
    console.error(e);
  }

  return null;
};
